
export class ImageModel {
    name: string;
    originalFile: File;
    dataUrl: string;
    preview: string;
    rawPreview: HTMLImageElement;
    originalWidth: number;
    originalHeight: number;
    date: Date;
    orientation: number;
    longitude: number;
    latitude: number;
    previewWidth: number;
    previewHeight: number;
    similarity: number;
    sequence: number;

    isDuplicate = false;
    duplicateList: ImageModel[];

    unchecked: boolean;

    postprocessed: boolean;
    preprocessed: boolean;
    thumbnailGenerated: boolean;


    constructor(init?: Partial<ImageModel>) {
        Object.assign(this, init);
    }
}

